import { render, staticRenderFns } from "./Permisos.vue?vue&type=template&id=4252eb4e&scoped=true"
import script from "./Permisos.vue?vue&type=script&lang=js"
export * from "./Permisos.vue?vue&type=script&lang=js"
import style1 from "./Permisos.vue?vue&type=style&index=1&id=4252eb4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252eb4e",
  null
  
)

export default component.exports